import React, { useCallback, useEffect, useMemo, useState } from 'react';
import cn from 'classnames/bind';
import styles from './styles.styl';
import { User } from '@consta/uikit/User';
import { Button } from '@consta/uikit/Button';
import { IconExit } from '@consta/uikit/IconExit';
import { useLocation, useNavigate } from 'react-router-dom';
import { PrivateRoutesEnum } from 'src/utils/router';
import { IconHamburger } from '@consta/uikit/IconHamburger';
import { Tabs } from '@consta/uikit/Tabs';
import { Sidebar } from '@consta/uikit/Sidebar';

import {
  Header as ConstaHeader,
  HeaderLogo,
  HeaderMenu,
  HeaderModule,
} from '@consta/uikit/Header';
import logoGazprom from 'src/assets/logoGazprom.svg';
import { useDispatch } from 'react-redux';
import UserService from 'src/services/UserService';
import { loadInfoUser } from 'src/redux/features/users/infoUser/actions';
import { useShallowEqualSelector } from 'src/customHooks/useShallowEqualSelector';
import { State } from 'src/redux/reducer';
import { Theme } from '@consta/uikit/Theme';
import { myPreset } from 'src/utils/myPreset';
import { useMediaQuery } from 'react-responsive';
import { storageRole } from 'src/utils/storage';
import { HeaderIdEnum, RoleEnum } from 'src/utils/enum';
import { currentUsersSelector } from 'src/redux/features/users/currentUsers/selectors';
import { userInitSelector } from 'src/redux/features/userInit/selectors';

const cx = cn.bind(styles);

interface Item {
  label: string;
  id: string;
  href?: string;
  active?: boolean;
  onClick?: React.EventHandler<React.MouseEvent>;
  target?: string;
  permission: number[];
}

export interface IHeaderProps {}

const Header: React.FC<IHeaderProps> = () => {
  const isMobile = useMediaQuery({ maxWidth: 460 });

  const dispatch = useDispatch();

  const location = useLocation();

  const navigate = useNavigate();

  const [currentUser, userInit] = useShallowEqualSelector((state: State) => [
    currentUsersSelector(state),
    userInitSelector(state),
  ]);

  const roleUser = useMemo(() => {
    return userInit?.roles.find((item) => item.key === currentUser?.role_name)
      ?.name;
  }, [currentUser, userInit]);

  const myLoc = `/${location.pathname.split('/').slice(1, 2).join('')}`;

  const items: Item[] = [
    {
      label: 'Мои модели',
      id: HeaderIdEnum.MY_MODEL,
      href: PrivateRoutesEnum.MY_MODEL,
      active: myLoc === PrivateRoutesEnum.MY_MODEL,
      onClick: (e) => {
        headerTransition(e, PrivateRoutesEnum.MY_MODEL);
      },
      permission: [],
    },
    {
      label: 'Все модели',
      id: HeaderIdEnum.ALL_MODEL,
      href: PrivateRoutesEnum.ALL_MODEL,
      active: myLoc === PrivateRoutesEnum.ALL_MODEL,
      onClick: (e) => {
        headerTransition(e, PrivateRoutesEnum.ALL_MODEL);
      },
      permission: [],
    },
    {
      label: 'Администрирование',
      id: HeaderIdEnum.ADMINISTRATION,
      href: PrivateRoutesEnum.ADMINISTRATION,
      active: myLoc === PrivateRoutesEnum.ADMINISTRATION,
      onClick: (e) => {
        headerTransition(e, PrivateRoutesEnum.ADMINISTRATION);
      },
      permission: [],
    },
    {
      label: 'Журнал событий',
      id: HeaderIdEnum.JOURNAL,
      href: PrivateRoutesEnum.JOURNAL,
      active: myLoc === PrivateRoutesEnum.JOURNAL,
      onClick: (e) => {
        headerTransition(e, PrivateRoutesEnum.JOURNAL);
      },
      permission: [],
    },
  ];

  const newItem = items.filter((item) => {
    if (
      item.id === HeaderIdEnum.ADMINISTRATION &&
      storageRole() !== RoleEnum.ADMIN
    ) {
      return null;
    } else if (
      item.id !== HeaderIdEnum.JOURNAL &&
      storageRole() === RoleEnum.SECURITY
    ) {
      return null;
    } else if (
      (item.id === HeaderIdEnum.ALL_MODEL ||
        item.id === HeaderIdEnum.JOURNAL) &&
      storageRole() === RoleEnum.USER
    ) {
      return null;
    } else {
      return item;
    }
  });

  const [isOpenMobileMenu, setOpenMobileMenu] = useState(false);
  const [valueTabs, setValueTabs] = useState(
    newItem.find((item) => item.href === myLoc),
  );

  useEffect(() => {
    dispatch(loadInfoUser(UserService.getUserInfo));
  }, [dispatch]);

  const logout = () => {
    navigate('/');
    UserService.doLogout();
  };

  const headerTransition = (e: React.MouseEvent, patch: string) => {
    e.preventDefault();
    navigate(patch);
  };

  const handleClickTabs = useCallback((value: Item, e: React.MouseEvent) => {
    if (value.id !== HeaderIdEnum.ADMINISTRATION) {
      setValueTabs(value);
    }
    value.onClick(e);
    setOpenMobileMenu(false);
  }, []);

  return (
    <Theme preset={myPreset}>
      <ConstaHeader
        className={cx('Header', { Header_up: isOpenMobileMenu })}
        leftSide={
          <div className={cx('Header__tabs')}>
            {isMobile ? (
              <IconHamburger
                onClick={() => setOpenMobileMenu((prev) => !prev)}
              />
            ) : (
              <>
                <HeaderLogo>
                  <img className={cx('Header__logo')} src={logoGazprom} />
                </HeaderLogo>
                <HeaderModule indent="s">
                  <HeaderMenu items={newItem} />
                </HeaderModule>
              </>
            )}
          </div>
        }
        rightSide={
          <div className={cx('Header__user')}>
            <User name={currentUser?.username || ''} info={roleUser} />
            <Button
              onlyIcon
              iconLeft={IconExit}
              view="clear"
              onClick={logout}
              className={cx('Header__button')}
            />
          </div>
        }
      />
      <Sidebar
        className={cx('Header__sideBar')}
        position="left"
        isOpen={isOpenMobileMenu && isMobile}
      >
        <Sidebar.Content className={cx('Header__sideBarContent')}>
          <Tabs
            value={valueTabs}
            onChange={({ value, e }) => handleClickTabs(value, e)}
            items={newItem}
            getLabel={(item) => item.label}
            size="s"
            linePosition="left"
            className={cx('Header__tabsMobile')}
          />
        </Sidebar.Content>
      </Sidebar>
    </Theme>
  );
};

export default Header;
